export default __webpack_public_path__ + "static/media/checkmark.ef01f6e5.svg";